<template>
    <div class="login" >
        <loading v-if="isVerifying" :alt="true"></loading>
    </div>
</template>


<script>
import api from 'js/api/resources';
import track from 'js/helpers/analytics';
import notify from 'js/components/notifications/notificationsMixin';
import Loading from 'js/components/elements/Loading.vue';

export default {
    name: 'EmailConfirm',
    mixins: [ notify ],
    components: { Loading },
    props: [],

    beforeRouteEnter: (to, from, next) => {

        if ( !to.params.token ) {
            this.$warn('E-mail bevestigingslink is niet geldig')
            return next({ name: 'register' })
        }

        next()

    },

    created: function() {

        api.confirmUserEmail(this.$route.params.token)
            .then( () => {
                this.$success('Jouw e-mailadres is aangepast')
            })
            .catch( e => {
                this.$warn('E-mail bevestigingslink is niet geldig')
                track.exception('Could not store new email', e, {token: this.$route.params.token})
            })
            .then( () => {
                this.$router.push({ name: 'root' })
            })

    },

}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// EmailConfirm.vue?1251c396